import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthState } from './lib/auth';
import LoginPage from './pages/LoginPage';
import AppShell from './components/AppShell';
import DashboardPage from './pages/DashboardPage';
import AnalyticsPage from './pages/AnalyticsPage';
import PricingPage from './pages/PricingPage';
import ServiceAreaPage from './pages/ServiceAreaPage';
import OperationsPage from './pages/OperationsPage';
import CatalogsPage from './pages/CatalogsPage';
import FeatureFlagsPage from './pages/FeatureFlagsPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import JobsPage from './pages/JobsPage';
import JobDetailPage from './pages/JobDetailPage';
import DriversPage from './pages/DriversPage';
import CustomersPage from './pages/CustomersPage';
import RefundsPage from './pages/RefundsPage';
import AuditLogPage from './pages/AuditLogPage';
import MonitoringPage from './pages/MonitoringPage';
import InboxPage from './pages/InboxPage';

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { loading, user } = useAuthState();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.isAdmin) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-4 text-slate-700">
        <h1 className="text-2xl font-semibold">Access denied</h1>
        <p>Your account does not have the admin role.</p>
        <a href="/login" className="text-brand-600 underline">
          Sign in with a different account
        </a>
      </div>
    );
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <RequireAdmin>
            <AppShell>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/service-area" element={<ServiceAreaPage />} />
                <Route path="/operations" element={<OperationsPage />} />
                <Route path="/catalogs" element={<CatalogsPage />} />
                <Route path="/feature-flags" element={<FeatureFlagsPage />} />
                <Route path="/orders" element={<OrdersPage />} />
                <Route path="/orders/:id" element={<OrderDetailPage />} />
                <Route path="/jobs" element={<JobsPage />} />
                <Route path="/jobs/:id" element={<JobDetailPage />} />
                <Route path="/drivers" element={<DriversPage />} />
                <Route path="/customers" element={<CustomersPage />} />
                <Route path="/refunds" element={<RefundsPage />} />
                <Route path="/audit" element={<AuditLogPage />} />
                <Route path="/monitoring" element={<MonitoringPage />} />
                <Route path="/inbox" element={<InboxPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppShell>
          </RequireAdmin>
        }
      />
    </Routes>
  );
}
